import {useEffect} from 'react';
import {HashRouter,Route,Routes} from 'react-router-dom';
import AmazonFinds from './pages/AmazonFinds';
import Archived from './pages/Archived';
import Home from './pages/Home';
import LTD from './pages/LTD';
import Music from './pages/Music';
import NotFound from './pages/NotFound';
import Portfolio from './pages/Portfolio';
import {installProfileFavicon} from './lib/favicon';
import {PROFILE_IMAGE_URL} from './data/profileImage';
import './App.css';

export default function App() {
  useEffect(()=> {
    let cleanup;
    let cancelled=false;

    installProfileFavicon(PROFILE_IMAGE_URL).then((release)=> {
      if (cancelled) release?.();
      else cleanup=release;
    });

    return ()=> {
      cancelled=true;
      cleanup?.();
    };
  },[]);

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ltd" element={<LTD />} />
        <Route path="/amazon-finds" element={<AmazonFinds />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/music" element={<Music />} />
        <Route path="/allarchived" element={<Archived />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}